'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import Code from 'UIComponents/elements/Code';

const ScopesList = ({
  scopes
}) => {
  return scopes.map(scope => /*#__PURE__*/_jsx(Code, {
    className: "m-right-2 m-bottom-1",
    children: scope
  }, scope));
};

ScopesList.propTypes = {
  scopes: PropTypes.arrayOf(PropTypes.string)
};
export default ScopesList;